import CustomerOrdersPage from "../components/pages/customerOrders/CustomerOrdersPage";

const routes = [
    {
        path: "/customerOrders",
        element: <CustomerOrdersPage />
    }
];

export default routes;
